'use client';

import { PageHeader } from '@/shared/layout';
import { Shield, Database, Share2, Lock, Cookie, UserCheck, Mail, type LucideIcon } from 'lucide-react';
import { usePageContent } from '@/core/i18n/content';
import { PRIVACY_CONTENT } from '@/core/i18n/content/privacy.content';

const SECTION_ICONS: LucideIcon[] = [Database, Shield, Share2, Lock, Cookie, UserCheck, Mail];

export function PrivacyPolicy() {
  const c = usePageContent(PRIVACY_CONTENT);

  return (
    <div id="legal-privacy-root" className="min-h-screen bg-hms-bg">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <PageHeader title={c.title} description={c.description} />
        <p id="legal-privacy-intro" className="mt-6 text-sm text-hms-textSub leading-relaxed">
          {c.intro}
        </p>
        <div id="legal-privacy-sections" className="mt-8 space-y-6">
          {c.sections.map((section, idx) => {
            const Icon = SECTION_ICONS[idx] || Shield;
            return (
              <section key={idx} id={`legal-privacy-section-${idx}`} className="rounded-xl border border-hms-border bg-hms-card p-6 space-y-3">
                <h2 className="text-base font-semibold text-hms-text flex items-center gap-2">
                  <Icon className="h-4 w-4 text-hms-gold" />
                  {section.title}
                </h2>
                <p className="text-sm text-hms-textSub leading-relaxed">{section.content}</p>
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
}
